module.exports = "<div class=\"container theme-showcase\" \n     [ngClass]=\"(displaysFull) ? 'container container-full theme-showcase' : 'container theme-showcase'\" \n     role=\"main\">\n    <router-outlet></router-outlet>\n</div> <!-- /container -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sections/section-search/section-search.component.html
// module id = ./src/app/components/sections/section-search/section-search.component.html
// module chunks = main